import './sentry';
// Kit first (tokens, then components), then Tailwind. Separate imports keep the
// Google Fonts @import at the top of bundle.css, where browsers honor it.
import './styles/kit/tokens.css';
import './styles/kit/bundle.css';
import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
